// src/components/NextcloudSettings.jsx
// Nextcloud connection settings section for the config page

import React from "react";
import { useNextcloud } from "../hooks/useNextcloud";

const NextcloudSettings = () => {
  const { isConnected, loginName, connecting, error, connect, disconnect } = useNextcloud();

  return (
    <div className="nextcloud-settings" style={{ marginTop: "2rem" }}>
      <h3 style={{ marginBottom: "1rem", color: "var(--text-color)" }}>Nextcloud</h3>

      {error && (
        <div
          style={{
            padding: "0.75rem 1rem",
            marginBottom: "1rem",
            borderRadius: "8px",
            backgroundColor: "rgba(239, 68, 68, 0.1)",
            color: "#ef4444",
            fontSize: "0.9rem",
          }}
        >
          {error}
        </div>
      )}

      {isConnected ? (
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <span
            style={{
              display: "inline-block",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "#22c55e",
            }}
          />
          <span style={{ color: "var(--text-color)", fontSize: "0.95rem" }}>
            Verbunden als <strong>{loginName}</strong>
          </span>
          <button
            className="btn btn-secondary btn-sm"
            onClick={disconnect}
            style={{ marginLeft: "0.5rem" }}
          >
            Trennen
          </button>
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <span
            style={{
              display: "inline-block",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "var(--text-bg-color)",
            }}
          />
          <span style={{ color: "var(--text-bg-color)", fontSize: "0.95rem" }}>
            Nicht verbunden
          </span>
          <button
            className="btn btn-primary btn-sm"
            onClick={connect}
            disabled={connecting}
            style={{ marginLeft: "0.5rem" }}
          >
            {connecting ? "Verbinde..." : "Mit Nextcloud verbinden"}
          </button>
        </div>
      )}

      <p
        style={{
          marginTop: "0.75rem",
          fontSize: "0.85rem",
          color: "var(--text-bg-color)",
        }}
      >
        Verbinden Sie sich mit Nextcloud, um Referenzbilder direkt in die Bibliothek zu exportieren.
      </p>
    </div>
  );
};

export default NextcloudSettings;
